module.exports = __webpack_public_path__ + "img/logo.40a7521d.png";